import { createContext, useContext, type ReactNode } from "react";
import { type PdpSalesData } from "~/SalesCampaign/utils";

/**
 * This is a generic context for sales data - useable everywhere except Campaign Page, where there's different logic
 */

const Context = createContext<PdpSalesData | undefined>(undefined);

export const useSalesData = () => useContext(Context);

export const SalesDataProvider = ({ children, value }: { children: ReactNode; value?: PdpSalesData }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
